/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".notes-distributor[_ngcontent-%COMP%]{text-align:right;position:absolute!important;right:20px;top:-50px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/themes/default/css/draft-email-ticket.component.less.shim.ngstyle.js.pre-build-optimizer.js